import * as _ from 'lodash';

import {
  FABRICATORS_REQUEST, FABRICATORS_SUCCESS, FABRICATORS_FAILURE,
  FABRICATORS_STATUS_REQUEST, FABRICATORS_STATUS_SUCCESS, FABRICATORS_STATUS_FAILURE,
  FABRICATORS_ALL_REQUEST, FABRICATORS_ALL_SUCCESS,
  ENTITIES_ASSIGN_SAVING, ENTITIES_ASSIGN_SAVED,
  SALES_PEOPLE_REQUEST, SALES_PEOPLE_SUCCESS, SALES_PERSON_ASSIGN_SUCCESS,
  SALES_PERSON_SELECT,
  POPUP_IN_PROGRESS, ENTITIES_ASSIGN_REMOVE
} from '../../constants/actionTypes';
import {getApiConfig} from '../../utilities/index';
import * as popupActions from '../../actions/A_Popups';
import {messageBox_Show} from "../../actions";
import {loadingDialog_show} from "../../actions";

const getFabricatorsMethods = getApiConfig('Users/GetFabricators');
const getSalesPeopleMethod = getApiConfig('Users/GetSalesPeople');
const changeFabricatorStatusMethods = getApiConfig('Users/EnableCustomer');
const assignEntityMethod = getApiConfig('Users/AssignEntity');
const assignSalesPersonMethod = getApiConfig('Users/AssignSalesPerson');

export const TYPES = {
  LOAD_CLONING_FAB_FEATURES_REQUEST: 'LOAD_CLONING_FAB_FEATURES',
  LOAD_CLONING_FAB_FEATURES_RESPONSE: 'LOAD_CLONING_FAB_FEATURES_RESPONSE',
  SET_CLONING_FEATURES_SELECTION: 'SET_CLONING_FEATURES_SELECTION',
  SET_CLONING_FEATURE_CHECKED: 'SET_CLONING_FEATURE_CHECKED',
  SET_CLONING_FEATURE_FILTERS: 'SET_CLONING_FEATURE_FILTERS',
  CLONE_FEATURES_REQUEST: 'CLONE_FEATURES_REQUEST',
  CLONE_FEATURES_RESPONSE: 'CLONE_FEATURES_RESPONSE',
  CLONE_FABRICATOR_REQUEST: 'CLONE_FABRICATOR_REQUEST',
  CLONE_FABRICATOR_RESPONSE: 'CLONE_FABRICATOR_RESPONSE',
  CLONE_FABRICATOR_CHANGE_GROUP: 'CLONE_FABRICATOR_CHANGE_GROUP',
  CLONE_FABRICATOR_SET_SEARCH_TERM: 'CLONE_FABRICATOR_SET_SEARCH_TERM',
  CLONE_FABRICATOR_RESET: 'CLONE_FABRICATOR_RESET'
};

export function cloneFabFeaturesReset() {
  return {
    type: TYPES.CLONE_FABRICATOR_RESET,
    payload: {}
  }
}

export function cloneFabricatorChangeGroup(newGroupName) {
  return {
    type: TYPES.CLONE_FABRICATOR_CHANGE_GROUP,
    payload: {newGroupName}
  }
}

export function cloneFabricatorSetSearchTerm(searchTerm) {
  return {
    type: TYPES.CLONE_FABRICATOR_SET_SEARCH_TERM,
    payload: {searchTerm}
  }
}

export const CloningGroupNameAll = '<All>';

/**
 *
 * @param fabricatorId {number}
 */
export function cloneFabricator(fabricatorId) {
  return dispatch => {
    dispatch(loadingDialog_show(true, "Loading...", 'Cloning fabricator...'));
    dispatch({type: TYPES.CLONE_FABRICATOR_REQUEST, payload: {fabricatorId}});
    getApiConfig('/fabricators/' + fabricatorId + '/clone')
      .post()
      .then(data => {
        dispatch({type: POPUP_IN_PROGRESS, payload:{show: false}});
        dispatch({type: TYPES.CLONE_FABRICATOR_RESPONSE, payload: data});
      })
  }
}


/**
 *
 * @param fabricatorId {number}
 */
export function cloneFabricatorNew(request) {
  return dispatch => {
    dispatch(loadingDialog_show(true, "Loading...", 'Cloning fabricator...'));
    dispatch({type: TYPES.CLONE_FABRICATOR_REQUEST, payload: {fabricatorId: request.sourceFabricatorId}});
    getApiConfig('/clone/fabricator')
      .post(request)
      .then(data => {
        dispatch({type: POPUP_IN_PROGRESS, payload:{show: false}});
        dispatch({type: TYPES.CLONE_FABRICATOR_RESPONSE, payload: data});
      })
  }
}

/**
 *
 * @param fabricatorId {number}
 * @param destinationFabricatorId {number}
 * @param copyFeaturesType {string} {all|new|overwrite}
 * @param cb
 */
export function cloneFeatures(fabricatorId, destinationFabricatorId, copyFeaturesType, cb) {
  return (dispatch, getState) => {
    const {fabricators} = getState();
    const {cloningFabFeaturesData} = fabricators;
    if (!destinationFabricatorId && !_.size(cloningFabFeaturesData)) {
      dispatch(messageBox_Show(true, 'error', 'Clone features', 'Destination fabricator is required.'));
      cb(true);
      return ;
    }

    destinationFabricatorId = destinationFabricatorId || _.first(cloningFabFeaturesData.fabricators).id;
    const data = {
      featureIds: _.filter(cloningFabFeaturesData.features, f => f.isChecked)
        .map(f => f.id),
      destinationFabricatorId,
      copyFeaturesType
    };

    dispatch({type: TYPES.CLONE_FEATURES_REQUEST, payload: {destinationFabricator: destinationFabricatorId}});
    dispatch(loadingDialog_show(true, "Loading...", 'Cloning features...'));
    getApiConfig('fabricators/' + fabricatorId + '/cloneFeatures')
      .post(data)
      .then(response => {
        dispatch({type: POPUP_IN_PROGRESS, payload:{show: false}});
        dispatch({type: TYPES.CLONE_FEATURES_RESPONSE, payload: response});
        cb(false);
      })
      .catch(error => {
        dispatch({type: POPUP_IN_PROGRESS, payload:{show: false}});
        dispatch(messageBox_Show(true, 'error', 'Error', typeof error === "string" ? error : error.message || error.text))
      })
  }
}

/**
 *
 * @param sourceFabricatorId {int}
 * @return {Function}
 */
export function getCloneFabricatorFeatures(sourceFabricatorId) {
  return dispatch => {
    dispatch(loadingDialog_show(true, "Loading...", 'Loading features...'));
    dispatch({type: TYPES.LOAD_CLONING_FAB_FEATURES_REQUEST, payload: {sourceFabricatorId}});
    getApiConfig('fabricators/' + sourceFabricatorId + '/cloneFabricatorFeatures')
      .get()
      .then(response => {
        console.log("cloningFeaturesResponse", response);
        dispatch({type: POPUP_IN_PROGRESS, payload:{show: false}});
        dispatch({type: TYPES.LOAD_CLONING_FAB_FEATURES_RESPONSE, payload: response});
      });
  }
}

/**
 *
 * @param selection {string}
 * @return {{payload: {selection: *}, type: string}}
 */
export function setCloningFeaturesSelection(selection) {
  return (dispatch, getState) => {
    if (!selection) { // just in case
      return
    }
    const store = getState();
    const {selectedFilters} = store.featuresFiltersState;
    dispatch({type: TYPES.SET_CLONING_FEATURES_SELECTION, payload: {selection, selectedFilters}})
  }
}

export function setCloningFeatureChecked({featureId, checked}) {
  return {type: TYPES.SET_CLONING_FEATURE_CHECKED, payload: {featureId, checked}};
}

export function setCloningFeatureFilters(projectScopeFeatures) {
  return (dispatch, getState) => {
    const store = getState();
    const {cloningFabFeaturesSelectedGroup, cloningFabFeaturesData} = store.fabricators;
    const {features} = cloningFabFeaturesData;
    const reversedFetures = projectScopeFeatures.reverse(); // White Springs should go before the White Spring
    let shouldUpdateFeatures = false;

    const cloneFeatureGroupFeatures = features.filter(feature => feature.groupName === cloningFabFeaturesSelectedGroup);

    for (let i = 0; i < cloneFeatureGroupFeatures.length; i++) {
      if (!cloneFeatureGroupFeatures[i] || !cloneFeatureGroupFeatures[i].featureName) {
        continue;
      }
      const featureWithFilterAndSameName = reversedFetures.find(psFeature => {
        // "Absolute Black Dal Tile Backsplash ver1 4in L" includes "Absolute Black"
        return psFeature.name && cloneFeatureGroupFeatures[i].featureName.includes(psFeature.name)
      });
      if (featureWithFilterAndSameName) {
        cloneFeatureGroupFeatures[i].filterValueIds = featureWithFilterAndSameName.filterValueIds;
        cloneFeatureGroupFeatures[i].fabFilterValueIds = featureWithFilterAndSameName.fabFilterValueIds;
        if (!shouldUpdateFeatures) {
          shouldUpdateFeatures = true;
        }
      } else {
        console.log("no feature found", cloneFeatureGroupFeatures[i]);
      }
    }

    console.log("project scope reversed features", reversedFetures);
    console.log("cloneFeatureGroupFeatures", cloneFeatureGroupFeatures);
    console.log("updated clone features with filters", cloneFeatureGroupFeatures.filter(feature => feature.filterValueIds || feature.fabFilterValueIds));

    dispatch({type: TYPES.SET_CLONING_FEATURE_FILTERS, payload: {features, shouldUpdateFeatures}});
  }
}

export const getFabricators = (page = 0, pageSize = 50, searchKeyword = '') => {
  return dispatch => {
    dispatch({
      type: FABRICATORS_REQUEST,
      searchKeyword
    });
    const data = {
      page,
      pageSize
    };
    if (searchKeyword) {
      data.FilterBy = {
        filter: searchKeyword
      }
    }
    return getFabricatorsMethods.post(data)
      .then(data => {
        dispatch({
          type: FABRICATORS_SUCCESS,
          data
        });
        return data
      })
  }
};

export const getAllFabricators = (searchKeyword, filterBy, entityType, page = 0) => {
  return dispatch => {
    dispatch({
      type: FABRICATORS_ALL_REQUEST,
      searchKeyword
    });
    const data = {
      page: page,
      pageSize: 50,
      FilterBy: {
        'assoc_fab_id': filterBy,
        entityType
      }
    };
    if (searchKeyword) {
      data.FilterBy.filter = searchKeyword;
    }
    getFabricatorsMethods.post(data)
      .then(data => {
        dispatch({
          type: FABRICATORS_ALL_SUCCESS,
          payload: data
        })
      });
  }
};

export const getFabricatorList = () => {
  return new Promise(resolve => {
    const getFabListApi = getApiConfig("Dashboard/");
    getFabListApi.get("GetFabricatorList").then(resolve);
  });
}

export const getSalesPeople = (jobId, jobIdType, searchKeyword = null, page = 0) => {
  return dispatch => {
    dispatch({type: SALES_PEOPLE_REQUEST});
    const data = {
      jobId,
      jobIdType,
      page: page,
      filterBy: {}
    };

    if (searchKeyword) {
      data.filterBy.name = searchKeyword;
    }

    getSalesPeopleMethod.post(data)
      .then(data => {
        dispatch({type: SALES_PEOPLE_SUCCESS, payload: data});
      });
  }
};

export const assignSalesPerson = () => {
  return (dispatch, getState) => {
    const state = getState();
    const job = state.popups.assignSalesPerson.get('job');
    const {salesPeople} = state.jobBoard;

    const userId = state.popups.assignSalesPerson.get('selectedId');

    if (!userId) {
      dispatch(popupActions.messageBox_Show(true, 'error', 'Error', 'Select a sales person.'));
      return ;
    }

    dispatch(loadingDialog_show(true, "", "Assigning sales person..."));

    const data = {
      jobId: job.id,
      jobIdType: job.jobIdType,
      salesPersonId: userId
    };

    assignSalesPersonMethod.post(data)
      .then(response => {
        let salesPerson = response && Array.isArray(response.rows)
          ? response.rows.find(person => person.userId === userId)
          : null;
        if (!salesPerson) {
          let rows = state.jobBoard.salesPeople.get('rows');
          rows = rows ? rows.toJS() : [];
          salesPerson = rows.find(person => person.userId === userId)
        }
        const salesPersonName = salesPerson ? salesPerson.userName : "";
        dispatch({
          type: SALES_PERSON_ASSIGN_SUCCESS,
          payload: {job, properties: {"salesPerson": salesPersonName}}
        }); // update jobs
        dispatch(loadingDialog_show(false));
        dispatch(popupActions.assignSalesPerson(null, false)); // hide popup
      })
  }
}

export const selectSalesPerson = (salesPersonId) => {
  return dispatch => {
    dispatch({type: SALES_PERSON_SELECT, payload:salesPersonId});
  }
}

export const assignEntities = (masterEntity, childEntities, entityType) => {
  return dispatch => {
    dispatch({type: ENTITIES_ASSIGN_SAVING});

    const data = {
      entityId: masterEntity.id,
      entityType,
      attachTo: childEntities
    };

    assignEntityMethod.post(data)
      .then(data => {
        dispatch({type: ENTITIES_ASSIGN_SAVED});
      })
  }
};

export const removeAllEntities = () => {
  return dispatch => {
    dispatch({type: ENTITIES_ASSIGN_REMOVE});
  }
};

export const changeFabricatorStatus = (fabricatorId, enabled) => {
  return dispatch => {
    dispatch({
      type: FABRICATORS_STATUS_REQUEST
    });

    changeFabricatorStatusMethods.post({customerId: fabricatorId, enabled, type: 'Fabricator'})
      .then(() => {
        dispatch({
          type: FABRICATORS_STATUS_SUCCESS,
          success: true
        })
      });
  }
};
